<fieldset class="flex flex-col gap-1.5" [class]="containerClass()">
  <legend class="checklist-task-label label" [class.sr-only]="hideLabel()">
    {{ labelText() }}
  </legend>

  @if (state().disabled()) {
    <output
      class="text-sm font-normal text-primary leading-6"
      [attr.id]="id()"
      role="note">
      {{ displayText() }}
    </output>
  } @else {
    <div class="flex flex-row flex-wrap items-center gap-2">
      @if (timeField()) {
        <nz-time-picker
          [formField]="partsForm.time"
          nzFormat="HH:mm"
          nzPlaceHolder="hh:mm"
          nzPopupClassName="clf-time-picker"
          [nzInputReadOnly]="false"
          [attr.id]="id()"
          class="checklist-input shrink-0 !w-[7rem]"
          [class.border-error]="showError()"
          [attr.aria-label]="label() + ' time'" />
      }
      @if (dateField()) {
        <nz-date-picker
          [formField]="partsForm.date"
          nzFormat="yyyy-MM-dd"
          nzPlaceHolder="yyyy-mm-dd"
          nzDropdownClassName="clf-date-picker"
          [nzInputReadOnly]="false"
          [attr.id]="timeField() ? null : id()"
          class="checklist-input shrink-0 !w-[9.75rem]"
          [class.border-error]="showError()"
          [attr.aria-label]="label() + ' date'" />
      }
    </div>
    @if (showError()) {
      <p class="text-error-primary m-0 p-0">This is a required field</p>
    }
  }
</fieldset>
